import { render } from "./FengMenuLeft.vue?vue&type=template&id=4bbf1918&scoped=true"
import script from "./FengMenuLeft.vue?vue&type=script&lang=js"
export * from "./FengMenuLeft.vue?vue&type=script&lang=js"

import "./FengMenuLeft.vue?vue&type=style&index=0&id=4bbf1918&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4bbf1918"]])

export default __exports__